import * as actionTypes from './types';
import {actionCreator} from "../shared/utility";

export const fetchPageTypes = actionCreator(actionTypes.FETCH_PAGE_TYPES);
export const fetchPageTypesSuccess = actionCreator(actionTypes.FETCH_PAGE_TYPES_SUCCESS);
export const fetchPageTypesFailed = actionCreator(actionTypes.FETCH_PAGE_TYPES_FAILED);